import { CreateHouseWalletTransactionInterface } from "../interfaces/HouseWalletTransactionInterfaces/CreateHouseWalletTransaction";
import { HouseWalletTransactionInterface } from "../interfaces/HouseWalletTransactionInterfaces/HouseWalletTransactionInterface";
import BaseService from "./BaseService";

export class HouseWalletTransactionService extends BaseService<HouseWalletTransactionInterface, CreateHouseWalletTransactionInterface>{ 
    constructor(){
        let url: string = '/house-wallet-transaction/admin'
        super(url)
    }
}